import { render } from "./LoadImage.vue?vue&type=template&id=3b20b44d"
import script from "./LoadImage.vue?vue&type=script&lang=js"
export * from "./LoadImage.vue?vue&type=script&lang=js"

import "./LoadImage.vue?vue&type=style&index=0&id=3b20b44d&lang=scss"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__